import { createSvgIcon } from '@material-ui/core';

export const DomainIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.9231 24C40.9231 33.3464 33.3464 40.9231 24 40.9231C14.6536 40.9231 7.07692 33.3464 7.07692 24C7.07692 14.6536 14.6536 7.07692 24 7.07692C33.3464 7.07692 40.9231 14.6536 40.9231 24ZM44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
      fill="currentColor"
    />
    <path
      d="M22.5937 23.2L25.8 17.6064L22.5937 12H16.2063L13 17.6064L16.2063 23.2H22.5937Z"
      fill="currentColor"
    />
    <path
      d="M22.5937 36L25.8 30.4064L22.5937 24.8H16.2063L13 30.4064L16.2063 36H22.5937Z"
      fill="currentColor"
    />
    <path
      d="M33.7937 29.6L37 24.0064L33.7937 18.4H27.4063L24.2 24.0064L27.4063 29.6H33.7937Z"
      fill="currentColor"
    />
  </svg>,
  'DomainIcon',
);
